import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.voice');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-voice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.voice/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.voice-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: #faf9f7;
}

.voice-orb {
  position: absolute;
  z-index: -2;
  top: -280px;
  right: -180px;
  width: 680px;
  height: 680px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(251, 146, 60, 0.2) 0%, rgba(253, 186, 116, 0.07) 45%, transparent 70%);
  pointer-events: none;
}

.voice-lines {
  position: absolute;
  z-index: -1;
  inset: 0;
  opacity: 0.32;
  background-image: repeating-linear-gradient(90deg, transparent 0, transparent 71px, rgba(161, 161, 170, 0.09) 72px);
  mask-image: linear-gradient(to right, transparent, black 25%, transparent 92%);
  -webkit-mask-image: linear-gradient(to right, transparent, black 25%, transparent 92%);
  pointer-events: none;
}

.voice-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #f97316;
  border: 1px solid rgba(249, 115, 22, 0.2);
  border-radius: 14px;
  background: rgba(255, 247, 237, 0.9);
  box-shadow: 0 8px 28px rgba(249, 115, 22, 0.08);
}

.live-dot {
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #f97316;
  box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.28);
  animation: live-pulse 2.2s ease-out infinite;
}

.sound-card {
  min-height: 410px;
  border: 1px solid rgba(228, 228, 231, 0.9);
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 30px 90px rgba(39, 39, 42, 0.09), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px);
}

.waveform span {
  display: block;
  width: 4px;
  border-radius: 9999px;
  background: linear-gradient(to top, #fb923c, #f97316);
  box-shadow: 0 3px 12px rgba(249, 115, 22, 0.18);
  animation: voice-wave 1.35s ease-in-out infinite alternate;
}

.waveform span:nth-child(1),
.waveform span:nth-child(17) {
  height: 16px;
}

.waveform span:nth-child(2),
.waveform span:nth-child(16) {
  height: 28px;
  animation-delay: -0.9s;
}

.waveform span:nth-child(3),
.waveform span:nth-child(15) {
  height: 46px;
  animation-delay: -0.3s;
}

.waveform span:nth-child(4),
.waveform span:nth-child(14) {
  height: 68px;
  animation-delay: -1.1s;
}

.waveform span:nth-child(5),
.waveform span:nth-child(13) {
  height: 94px;
  animation-delay: -0.55s;
}

.waveform span:nth-child(6),
.waveform span:nth-child(12) {
  height: 62px;
  animation-delay: -0.15s;
}

.waveform span:nth-child(7),
.waveform span:nth-child(11) {
  height: 112px;
  animation-delay: -0.75s;
}

.waveform span:nth-child(8),
.waveform span:nth-child(10) {
  height: 76px;
  animation-delay: -0.42s;
}

.waveform span:nth-child(9) {
  height: 132px;
  animation-delay: -1s;
}

.play-button {
  display: flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 9999px;
  background: #18181b;
  box-shadow: 0 8px 20px rgba(24, 24, 27, 0.16);
}

@keyframes live-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.28);
  }
  70% {
    box-shadow: 0 0 0 9px rgba(249, 115, 22, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 115, 22, 0);
  }
}
@keyframes voice-wave {
  from {
    transform: scaleY(0.58);
    opacity: 0.62;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .live-dot,
  .waveform span {
    animation: none;
  }
}`],
})
export class PageVoiceComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageVoiceComponent;